<template>
  <v-row justify="center">
    <v-dialog v-model="showModal" persistent max-width="800px">
      <v-card>
        <v-card-title>
          <span class="headline">{{ $t("DICOM Client") }}</span>
        </v-card-title>

        <v-card-text>
          <v-container>
            <v-form ref="form" v-model="valid" lazy-validation>
              <v-row>
                <v-col cols="12">
                  <v-text-field
                    v-model="name"
                    :rules="inputRules"
                    :label="$t('Name')"
                    :class="{'disable-events': !savingEnable}"
                    required
                    dense
                  ></v-text-field>
                </v-col>
                <v-col cols="12">
                  <v-text-field
                    v-model="aeTitle"
                    :rules="inputRules"
                    :label="$t('AE Title')"
                    :class="{'disable-events': !savingEnable}"
                    required
                    dense
                  ></v-text-field>
                </v-col>
                <v-col cols="12">
                  <v-text-field
                    v-model="ip"
                    :rules="inputRules"
                    :label="$t('IP Address')"
                    :class="{'disable-events': !savingEnable}"
                    required
                    dense
                  ></v-text-field>
                </v-col>
                <v-col cols="12">
                  <v-text-field
                    v-model="port"
                    :label="$t('Port')"
                    :class="{'disable-events': !savingEnable}"
                    :rules="[portRule]"
                    type="number"
                    dense
                  ></v-text-field>
                </v-col>
                <v-col cols="12" class="pb-0 pt-0">
                  <v-autocomplete
                    v-model="transfersSCP"
                    :items="transfersItems"
                    :class="{'disable-events': !savingEnable}"
                    chips
                    small-chips
                    :label="$t('Preferred Transfer Syntaxes')"
                    multiple
                    outlined
                  ></v-autocomplete>
                </v-col>

                <v-col cols="12" class="outlinedButton">
                  <v-btn
                    class="ma-2"
                    tile
                    outlined
                    color="red"
                    dense
                    v-show="deleteButton"
                    v-if="savingEnable"
                    @click="remove"
                  >
                    <v-icon left>mdi-delete</v-icon>{{ $t("Delete Client") }}
                  </v-btn>
                </v-col>
              </v-row>
            </v-form>
          </v-container>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="darken-1" @click="hide" text>{{ $t("Close") }}</v-btn>
          <v-btn color="darken-1" @click="save" :disabled="!valid" v-if="savingEnable" text>{{ $t("Save") }}</v-btn>
        </v-card-actions>

      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
import i18n from "../../i18n";

export default {
  name: "DicomClientModal",
  data: () => ({
    id: null,
    action: null,
    valid: false,
    showModal: false,
    name: "",
    aeTitle: "",
    ip: "",
    port: 0,
    transfersSCP: [],
    transfersItems: [],
    deleteButton: false,
    savingEnable: false,
    inputRules: [
      v => !!v || i18n.t('Required field')
    ],
    portRule: val => {
      if(val < 0) return 'Please enter a positive number.'
      return true
    }
  }),
  mounted() {
    let configuration = this.$store.getters.resources.configuration;
    this.transfersItems = this.$transfers.items;
    if (configuration.dicom.update) {
      this.savingEnable = true;
    }
  },
  methods: {
    show(clientData, counter) {
      if (clientData == null) {
        // New Client
        if (this.$refs.form) this.$refs.form.resetValidation();
        this.deleteButton = false;
        this.id = counter;
        this.name = "";
        this.aeTitle = "";
        this.ip = "";
        this.port = 0;
        this.transfersSCP = this.$transfers.default;
        this.action = "new";
      } else {
        // Update Client
        this.deleteButton = true;
        this.id = clientData.id;
        this.name = clientData.name;
        this.aeTitle = clientData.aeTitle.trim();
        this.ip = clientData.ip;
        this.port = clientData.port;
        this.transfersSCP = this.$transfers.translate_uid(clientData.preferredScp);
        this.action = "update";
      }

      this.showModal = true;
    },
    hide() {
      this.loading = false;
      this.showModal = false;
    },
    save() {
      this.$emit(this.action, {
        id: this.id,
        name: this.name,
        aeTitle: this.aeTitle,
        ip: this.ip,
        port: Number(this.port),
        preferredScp: this.$transfers.translate_name(this.transfersSCP),
        send: false,
        archive: false,
      });
      this.hide();
    },
    remove() {
      this.action = "remove";
      this.save();
    },
    checkNested(obj, level, ...rest) {
      if (obj === undefined) return false;
      if (rest.length == 0 && {}.hasOwnProperty.call(obj, level)) return true;
      return this.checkNested(obj[level], ...rest);
    },
  },
};

</script>

<style scoped>
  .v-alert {
    overflow: hidden;
  }

  .disable-events {
    pointer-events: none;
  }
</style>